// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BC__","fullView":"styles_fullView__29HWT"};